<p>sign-up-dialog works!</p>
